import React from "react";

import Intro from "../../../../../../presentation/pages/auth/developer/intro";

const MakeIntro: React.FC = () => <Intro />;

export default MakeIntro;
